import { type AuthTokenResponse, getAccessTokenforResourceAsLazy } from 'owa-tokenprovider';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';

const getAccessToken = (): [
    string | AuthTokenResponse | undefined,
    Promise<string | AuthTokenResponse | undefined> | undefined
] => {
    return getAccessTokenforResourceAsLazy(
        window.location.origin, // resource: string,
        'BookingsB2Service', // apiName?: string,
        undefined, // requestId?: string,
        undefined, // targetTenantId?: string,
        undefined, // wwwAuthenticateHeader?: string,
        undefined, // showFullTokenResponse?: boolean,
        true, // preferIdpToken?: boolean,
        getGlobalSettingsAccountMailboxInfo() // mailboxInfo?: MailboxInfo,
    );
};

export default getAccessToken;
